//#region src/base.ts
const isNil = (a) => a === void 0 || a === null;
const isNotNil = (a) => !isNil(a);
const isNilOrEmpty = (a) => isNil(a) || a === "";
const isBlankOrNil = (value) => isNil(value) || !Array.isArray(value) && String(value).trim() === "";
const isNumber = (value) => !isBlankOrNil(value) && Boolean(value) !== value && !Array.isArray(value) && Number.isFinite(value);
const isNumberOrBlankOrNil = (value) => isBlankOrNil(value) || isNumber(value);
const getOrDefault = (optional, defaultValue) => {
	return isNil(optional) ? defaultValue : optional;
};
const isJsonArray = (json) => {
	return Array.isArray(json);
};
const isJsonObject = (json) => {
	return json !== null && typeof json === "object" && !isJsonArray(json);
};
//#endregion
export { getOrDefault, isBlankOrNil, isJsonArray, isJsonObject, isNil, isNilOrEmpty, isNotNil, isNumber, isNumberOrBlankOrNil };
